module.exports = __webpack_public_path__ + "img/62ne.3b8fc550.svg";